import React, { useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from "emailjs-com";

const RECAPTCHA_SITE_KEY = "6LfxuGErAAAAAAxLUQPdPKHmuJ7RCjfbCg1dWviH";

const FloatingContactButton = () => {
  const [showForm, setShowForm] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(true);
  const [verified, setVerified] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleSubmit = () => {
    const { name, phone, email, message } = formData;

    if (!name || !phone) {
      alert("Name and Phone are required!");
      return;
    }

    if (!verified) {
      alert("Please complete the reCAPTCHA");
      return;
    }

    const templateParams = {
      name,
      phone,
      email,
      message,
    };

    emailjs
      .send(
        "service_b3yqywd", // e.g. gmail_service
        "template_1x36hgh", // e.g. contact_form
        templateParams,
        "rY9vFvRxCpuP3HxL4" // e.g. Yx2Tlgk1Aq...
      )
      .then(() => {
        alert("Email sent successfully!");
        setShowForm(false);
        setVerified(false);
        setFormData({ name: "", phone: "", email: "", message: "" });
      })
      .catch((error) => {
        console.log("FAILED...", error);
        alert("Failed to send email.", error);
      });
  };

  useEffect(() => {
    const checkScreen = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
    };
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function handleInputChange(e) {
    const { name, value } = e.target;

    if (name === "email") {
      setFormData((prev) => ({ ...prev, [name]: value }));

      if (isValidEmail(value)) {
        setEmailError("");
        setFormData((prev) => ({ ...prev, [name]: value }));
      } else {
        setEmailError("Invalid email format");
      }
    } else if (name === "phone") {
      if (/^\d*$/.test(value)) {
        setPhoneError("");
        setFormData((prev) => ({ ...prev, [name]: value }));
      } else {
        setPhoneError("Phone number must contain digits only");
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  }

  const handleRecaptchaChange = (value) => {
    setVerified(true);
  };

  //   const handleSubmit = () => {
  //     const { name, phone, email, message } = formData;
  //     if (!name || !phone) {
  //       alert("Name and Phone are required!");
  //       return;
  //     }
  //     if (!verified) {
  //       alert("Please complete the reCAPTCHA");
  //       return;
  //     }

  //     const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=mohsensleiman6@gmail.com&su=${encodeURIComponent(
  //       "From Web"
  //     )}&body=${encodeURIComponent(
  //       `${name}\n\n${phone}\n\n${email || "No email provided"}\n\n${message}`
  //     )}`;
  //     window.open(gmailLink, "_blank");

  //     setShowForm(false);
  //     setVerified(false);
  //     setFormData({ name: "", phone: "", email: "", message: "" });
  //   };

  if (!isLargeScreen) return null;

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setShowForm(true)}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          backgroundColor: "#DAA520",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "60px",
          height: "60px",
          fontSize: "24px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          zIndex: 9999,
        }}
      >
        ✉️
      </button>

      {/* Sidebar Modal */}
      {showForm && (
        <div
          onClick={() => setShowForm(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(6px)",
            zIndex: 9998,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              backgroundColor: "#fff",
              borderRadius: "8px 0 0 8px",
              padding: "30px",
              width: "100%",
              maxWidth: "400px",
              height: "100%",
              boxShadow: "-5px 0 15px rgba(0,0,0,0.3)",
              overflowY: "auto",
              transform: "translateX(0)",
              transition: "transform 0.3s ease-in-out",
            }}
          >
            <h3 style={{ marginBottom: "20px" }}>Contact Us</h3>
            <input
              name="name"
              placeholder="Full Name*"
              value={formData.name}
              onChange={handleInputChange}
              style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
            />
            <input
              name="phone"
              placeholder="Phone Number*"
              type="tel"
              pattern="[0-9]*"
              inputMode="numeric"
              value={formData.phone}
              onChange={handleInputChange}
              style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
            />
            {phoneError && (
              <div style={{ color: "red", marginBottom: "10px" }}>
                {phoneError}
              </div>
            )}

            <input
              name="email"
              placeholder="Email (Optional)"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
              style={{ width: "100%", marginBottom: "5px", padding: "8px" }}
            />
            {emailError && (
              <div style={{ color: "red", marginBottom: "10px" }}>
                {emailError}
              </div>
            )}
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleInputChange}
              rows={4}
              style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
            ></textarea>

            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              onChange={handleRecaptchaChange}
              style={{ marginBottom: "15px" }}
            />

            <button
              onClick={handleSubmit}
              style={{
                backgroundColor: "#DAA520",
                color: "#fff",
                padding: "10px",
                border: "none",
                width: "100%",
                cursor: "pointer",
              }}
            >
              Send
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingContactButton;
